import ProjectCard from "../../Components/ProjectCard";
import { useContext } from "react";
import { BlogsContext } from "../../utils/context";
import { variants } from "../../utils/animations";
import { motion } from "framer-motion";
import "./styles.css";

const Projects = () => {
  const blogsData = useContext(BlogsContext);
  const blogs = blogsData.filter((v) => v.type === "project");

  return (
    <>
      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='project__container'
      >
        <motion.div variants={variants} className='project__title'>
          <motion.h1 variants={variants}>
            From research to wireframes to pixels to prototypes to testing and
            marketing, I manage the end-to-end process of connecting user needs
            with business goals.
          </motion.h1>

          <h3>Projects</h3>
        </motion.div>

        {blogs?.map((item, index) => (
          <ProjectCard
            key={item.guid}
            title={item.title}
            thumbnail={item.thumbnail}
            description={item.description}
            content={item.content}
            timestamp={item.pubDate}
            subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
            width={"wide"}
          />
        ))}
      </motion.div>
    </>
  );
};

export default Projects;
